var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast--box"},_vm._l((_vm.toasts),function(toast){return _c('t-template',{key:toast.notificationId,staticClass:"toast set-flex",attrs:{"toast":toast}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }